export default __webpack_public_path__ + "static/media/polly-tab-logo-lockup-white-text.4ecd3a6a.svg";